<template>
  <b-container class="py-3">
    <custom-section id="about" source="About"/>

    <footer class="footer clearfix">
      <span class="text-muted float-right" title="Internal product version">
        IXMP Scenario Explorer v{{version}}
      </span>
    </footer>
  </b-container>
</template>

<script>
  import CustomSection from './CustomSection';

  export default {
    name: 'About',
    components: {CustomSection},
    computed: {
      version() {
        return this.$version.hash ? `${this.$version.version}-${this.$version.hash}` : this.$version.version;
      }
    }
  };
</script>

<style lang="scss">
</style>
